import { useAuthStore } from './authStore';
import { creditBalance, hasActivePlan } from './sessionMapper';

/**
 * Grants are per location — read them from `access`, never from a cached role.
 */
export function usePermissions() {
  const access = useAuthStore((state) => state.access);

  const permissions: string[] = access?.permissions ?? [];

  const hasPermission = (permission: string): boolean => permissions.includes(permission);

  const hasAnyPermission = (candidates: string[]): boolean =>
    candidates.some((candidate) => hasPermission(candidate));

  return {
    permissions,
    role: access?.role ?? null,
    plans: access?.plans ?? [],
    credits: access?.credits ?? [],
    hasPermission,
    hasAnyPermission,
    canSeeOtherLocations: hasPermission('cross_location'),
    hasActivePlan: hasActivePlan(access),
    creditBalance: (type: string) => creditBalance(access, type),
  };
}
